export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\"]',
  product: 'SA',
  brand: 'HM',
  apiV2RootUrl: 'https://assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: '4b3dcc26-4751-41e6-8b52-328d2684a113',
  assGarantie:
    'https://saboiarpbackofficex5he1.blob.core.windows.net/public/HM_Plaquette_Assurance_Sante_Animal_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://stats.groupe-vyv.fr/',
  matomoScriptUrl: 'https://stats.groupe-vyv.fr/js/container_682wvypB.js',
  msalConfig: {
    auth: {
      clientId: '22383aac-0c0e-485a-9cf6-cc58858282c2',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri:
        'https://assurance-sante-animale.harmonie-mutuelle.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-prd-back-office/Read.All', 'api://boiard-prd-back-office/Write.All'],
    uri: 'https://assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC',
  skeepersTagId: '0ca9a77d9faddd0653a92063233c1633-3967',
};
